import service from '@/store/services/users-service';
import axios from 'axios'

const state = {
	list: {},
	user: {},
	meta: {},
	url: null
};

const mutations = {
	SET_LIST: (state, list) => {
		state.list = list;
	},
	SET_RESOURCE: (state, user) => {
		state.user = user;
	},
	SET_META: (state, meta) => {
		state.meta = meta;
	},
	SET_URL: (state, url) => {
		state.url = url;
	}
};

const options = {
	headers: {
		'Accept': 'application/vnd.api+json',
		'Content-Type': 'application/vnd.api+json',
	}
};

const actions = {
	list({commit, dispatch}, params) {
		return service.list(params)
			.then(({list, meta}) => {
				commit('SET_LIST', list);
				commit('SET_META', meta);
			});
	},

	get({commit, dispatch}, params) {
		return service.get(params)
			.then((user) => { commit('SET_RESOURCE', user); });
	},

	add({commit, dispatch}, params) {
		return service.add(params)
			.then((user) => { commit('SET_RESOURCE', user); });
	},

	update({commit, dispatch}, params) {
		return service.update(params)
			.then((user) => { commit('SET_RESOURCE', user); });
	},

	destroy({commit, dispatch}, params) {
		return service.destroy(params);
	},

	upload({commit, dispatch}, {user, image}) {
		return service.upload(user, image)
			.then((url) => {
				commit('SET_URL', url);
			});
	},

	updatePassword(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL+'/password/update', payload)
			.then((response) => {
				return response
			})
	},

	fetchActive() {
		return axios.get(process.env.VUE_APP_API_BASE_URL+'/users/fetch/active')
			.then((response) => {
				return response
			})
	},

	fetchActiveTechnicians(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL+'/technicians/fetch/active')
			.then((response) => {
				return response
			})
	},

	getTechnicians(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/technicians', payload, options)
			.then((response) => {
				return response
			})
	},

	getTechnicianDetails(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/technicians/' + payload.id)
			.then((response) => {
				return response
			})
	}

};

const getters = {
	list: state => state.list,
	listTotal: state => state.meta.page.total,
	user: state => state.user,
	url: state => state.url
};

const users = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default users;
